import type { SetupAdaToIntercomHandoffOptions } from "./types";

const registerIntercomHandoffListeners = (): void => {
  if (window.intercomHandoffListenersRegistered || typeof window.Intercom !== "function") {
    return;
  }

  window.intercomHandoffListenersRegistered = true;
  window.Intercom("onShow", () => {
    window.intercomHandoffEventHandlers?.onShow?.();
  });
  window.Intercom("onHide", () => {
    window.intercomHandoffEventHandlers?.onHide?.();
  });
};

const setupAdaToIntercomHandoff = (options: SetupAdaToIntercomHandoffOptions = {}): void => {
  window.intercomHandoffEventHandlers = options;
  window.performAdaToIntercomHandoff = () => {
    window.adaEmbed?.toggle();

    if (typeof window.Intercom !== "function") {
      return;
    }

    registerIntercomHandoffListeners();
    window.Intercom("show");
    window.Intercom("showNewMessage");
  };
};

export { setupAdaToIntercomHandoff };
